/* global Swiper */
// *******************************************************************************
// Steps Slider
// *******************************************************************************

const stepsSliderElements = document.querySelectorAll('[data-slider="steps-slider"]');

const stepsSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 12,
  speed: 300,
  watchOverflow: true,
  autoHeight: false,
};

stepsSliderElements.forEach((el) => {
  const stepslider = new Swiper(el, stepsSliderOptions);
});

// **************************************************

attachEvent('.open-steps-form', 'click', (ev) => {
  const forms = ev.target.closest('.steps__content').querySelectorAll('.step__form');
  forms.forEach((form) => {
    form.classList.toggle('is-active');
  });
});

// **************************************************

attachEvent('.step__form .checkbox input', 'click', (ev) => {
  const stepForm = ev.target.closest('.step__form');
  const checkboxes = stepForm.querySelectorAll('.checkbox input');
  const button = stepForm.querySelector('.step__form-submit');

  const allChecked = [...checkboxes].some((checkbox) => !checkbox.checked);

  button.classList.toggle('is-disabled', allChecked);
});

// *******************************************************************************
// Validation
// *******************************************************************************

document.addEventListener('DOMContentLoaded', () => {
  const stepForms = document.querySelectorAll('.step__form');
  const recaptchaKey = document.querySelector('.g-captcha').getAttribute('data-sitekey');
  stepForms.forEach((stepForm) => {
    const stepFormParent = stepForm.closest('.step');
    const fv = FormValidation.formValidation(stepForm, {
      locale: 'sl_SI',
      localization: FormValidation.locales.sl_SI,
      fields: {},
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) => element.closest('.step__input, .checkbox'),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        trigger: new FormValidation.plugins.Trigger(),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    })
      .on('core.element.validated', (e) => {
        // e.element presents the field element
        // e.valid indicates the field is valid or not

        // Get the field value
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(e.element, '.step__input, .checkbox');
        FormValidation.utils.classSet(container, { 'is-validation-failed': !e.valid && value === '' });
      })
      .on('core.form.valid', () => {
        const loading = document.querySelector('.loading');
        loading.classList.add('is-active');
        grecaptcha.ready(() => {
          grecaptcha.execute(recaptchaKey, { action: 'saveOrderBrochure' }).then((token) => {
            const submitButton = document.querySelector('.step__form-submit');
            submitButton.classList.add('is-disabled');
            const formData = {};
            const formDataImage = new FormData();
            const form = document.querySelector('#step-form');
            form.querySelectorAll('input, textarea').forEach((input) => {
              formData[input.name] = input.value.trim();
            });
            formDataImage.append('action', formData.action);
            formDataImage.append('inputs', JSON.stringify(formData));
            formDataImage.append('lang', localData.lang);
            formDataImage.append('id', localData.id);
            formDataImage.append('token', token);
            formDataImage.append('nonce', formData.nonce);
            axios
              .post(localData.siteURL, formDataImage, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              })
              .then((response) => {
                stepFormParent.querySelector('.step__thankyou').innerHTML = response.data.data.message;
                stepFormParent.classList.add('show-thankyou');
                loading.classList.remove('is-active');
              })
              .catch((e) => {
                submitButton.classList.remove('is-disabled');
                stepFormParent.classList.add('show-thankyou');
                stepFormParent.querySelector('.step__thankyou').innerHTML = e.response.data.data.message;
                loading.classList.remove('is-active');
              });
          });
        });
      });
  });
});
